import { useContext } from 'react'

import { connect, useData } from 'scrivito'

import { DisplayCount } from '@/Atomic/Molecules/DisplayCount'
import { EntityListContext } from '@/Components/EntityListContext'
import { getEntityLabelKey } from '@/utils/getEntityLabelKey'

interface DisplayCountIndicatorProps {
  dataClassName?: string
}

export const DisplayCountIndicator = connect(function DisplayCountIndicator({
  dataClassName,
}: DisplayCountIndicatorProps) {
  const { hasMore } = useContext(EntityListContext)
  const dataScope = useData()

  if (!dataScope?.take().length) {
    return
  }

  const amount = dataScope?.take().length || 0
  const total = dataScope?.count() || 0
  const resolvedLabelKey = getEntityLabelKey(
    dataClassName || dataScope?.dataClassName() || '',
  )
  const showRestrictedCountHint = !hasMore() && amount < total

  return (
    <DisplayCount
      amount={amount}
      total={total}
      labelKey={resolvedLabelKey}
      showRestrictedHint={showRestrictedCountHint}
    />
  )
})
